import React from 'react';
import styled from 'styled-components';
import { AnimatePresence, motion } from 'framer-motion';
import { FileText, FileType, X } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const Overlay = styled(motion.div)`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Modal = styled(motion.div)`
  background: ${props => props.theme.mode === 'dark' ? '#1e1e1e' : '#ffffff'};
  border: 1px solid ${props => props.theme.mode === 'dark' ? '#30363d' : '#e1e4e8'};
  border-radius: 12px;
  width: 420px;
  padding: 20px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 18px;
  color: ${props => props.theme.mode === 'dark' ? '#f0f6fc' : '#24292e'};
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.mode === 'dark' ? '#8b949e' : '#6a737d'};
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  &:hover { background: ${props => props.theme.mode === 'dark' ? '#21262d' : '#f6f8fa'}; }
`;

const OptionList = styled.div`
  display: grid;
  gap: 12px;
`;

const Option = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px;
  background: ${props => props.theme.mode === 'dark' ? '#21262d' : '#f6f8fa'};
  color: ${props => props.theme.mode === 'dark' ? '#f0f6fc' : '#24292e'};
  border: 1px solid ${props => props.theme.mode === 'dark' ? '#30363d' : '#d1d9e0'};
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  transition: transform .12s ease;
  &:hover { transform: translateY(-1px); }
`;

const OptionLabel = styled.div`
  display: flex;
  flex-direction: column;
`;

const OptionTitle = styled.span`
  font-weight: 600;
`;

const OptionDesc = styled.span`
  font-size: 12px;
  color: ${props => props.theme.mode === 'dark' ? '#8b949e' : '#6a737d'};
`;

const SaveAsModal = ({ isOpen, onClose, onSelect }) => {
  const { theme } = useTheme();
  return (
    <AnimatePresence>
      {isOpen && (
        <Overlay
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <Modal
            theme={theme}
            initial={{ scale: .95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: .95, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <Header>
              <Title theme={theme}>형식 선택하여 저장</Title>
              <CloseButton theme={theme} onClick={onClose}><X size={18} /></CloseButton>
            </Header>
            <OptionList>
              <Option theme={theme} onClick={() => onSelect('docx')}>
                <FileText size={18} color="#0969da" />
                <OptionLabel>
                  <OptionTitle>.docx (Word)</OptionTitle>
                  <OptionDesc theme={theme}>서식 유지, Word에서 편집 가능</OptionDesc>
                </OptionLabel>
              </Option>
              <Option theme={theme} onClick={() => onSelect('pdf')}>
                <FileType size={18} color="#d6336c" />
                <OptionLabel>
                  <OptionTitle>.pdf (PDF)</OptionTitle>
                  <OptionDesc theme={theme}>공유/배포용으로 적합(미리보기 누른 후 저장하세요.)</OptionDesc>
                </OptionLabel>
              </Option>
            </OptionList>
          </Modal>
        </Overlay>
      )}
    </AnimatePresence>
  );
};

export default SaveAsModal;


